import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Input from 'antd/es/input';

import './Input.scss';

/**
 * Inputs.
 */
export const InputGroup = Input.Group;
export const SearchInput = Input.Search;
export const TextArea = Input.TextArea;
export const PasswordInput = Input.Password;
export const TextInput = React.memo( React.forwardRef( ( p, ref ) => {

  return(
    <Input className="Input"
    ref={ ref }
    { ...p }
    onBlur={ !! p.onBlur ? change => p.onBlur( p.value ) : null }
    />
  )

} ) );

export const Masked = React.memo( React.forwardRef( ( p, ref ) => {

  return(
    <Input className="Input"
    ref={ ref }
    { ...p }
    onBlur={ !! p.onBlur ? change => p.onBlur( p.value ) : null }
    />
  )

} ) );

export default TextInput;